import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import ClientImportTemplateDetails from './clientImportTemplateDetails';

export default class AddClientImportTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: false
        };
    }

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        return (
            <div>
                <button className="btn btn-primary button-info-grid" onClick={() => this.handleShow()}>
                    <i className="fas fa-plus"></i> Add Template
                </button>
                <ModalStyled
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Add Template</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ClientImportTemplateDetails context={this.props.context} handleClose={this.handleClose} />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
